import {isMobileScreen} from '../utils';

export default function () {
    const headerEl = document.querySelector('.js-header')
    const heroEl = document.querySelector('.js-hero-module')
    const searchButton = document.querySelector('.js-open-search-panel')
    const searchPanel = document.querySelector('.js-search-panel')

    // Loop through all Nav groups
    document.querySelectorAll('.js-nav-group').forEach(navGroup => {
        const subNavTriggerMobile = navGroup.querySelector('.js-sub-nav-trigger-mobile');
        if (subNavTriggerMobile) {
            subNavTriggerMobile.addEventListener('click', (e) => {
                navGroup.classList.add('is-active');
            });
        }
        const subNavBackButton = navGroup.querySelector('.js-sub-nav-back-mobile');
        if (subNavBackButton) {
            subNavBackButton.addEventListener('click', (e) => {
                navGroup.classList.remove('is-active');
            });
        }

        const firstNavGroup = document.querySelector('.js-nav-group');
        navGroup.addEventListener('mouseenter', () => {
            if (!isMobileScreen()) {
                const navDropdown = navGroup.querySelector('.js-nav-dropdown');
                if (navDropdown) {
                    navDropdown.style.paddingLeft = firstNavGroup.offsetLeft - parseInt(window.getComputedStyle(navDropdown.parentElement).paddingLeft) + 'px';
                    document.documentElement.classList.add('has-active');
                }
            }
        });
        navGroup.addEventListener('mouseleave', () => {
            if (!isMobileScreen()) {
                document.documentElement.classList.remove('has-active');
            }
        })
    })

    searchButton.addEventListener('click', (e) => {
        e.stopPropagation();
        searchPanel.classList.add('opacity-100', 'pointer-events-auto');
        searchPanel.classList.remove('opacity-0', 'pointer-events-none');
    });

    document.addEventListener('click', (e) => {
        const isClickInsidePanel = searchPanel.contains(e.target);
        if (!isClickInsidePanel) {
            searchPanel.classList.remove('opacity-100', 'pointer-events-auto');
            searchPanel.classList.add('opacity-0', 'pointer-events-none');
        }
    });

    document.querySelector('.js-mobile-menu-toggle').addEventListener('click', e => {
        if (document.documentElement.classList.contains('has-mobile-menu')) {
            document.documentElement.classList.remove('has-active');
            document.documentElement.classList.remove('has-mobile-menu');
        } else {
            document.documentElement.classList.add('has-mobile-menu');
            document.documentElement.classList.add('has-active');
        }
    })

    if (heroEl) {
        window.addEventListener('scroll', ev => {
            if (heroEl.getBoundingClientRect().top < -40) {
                headerEl.classList.add('has-scrolled-long')
            } else {
                headerEl.classList.remove('has-scrolled-long')
            }
        })
    }

    const navLinks = document.querySelectorAll('.js-nav-group a');
    const mobileNavLinks = document.querySelectorAll('.js-mobile-nav-links');

    function normalizePath(path) {
        if (path.length > 1 && path.endsWith("/")) {
            return path.slice(0, -1); // remove trailing slash
        }
        return path;
    }

    const currentPath = normalizePath(window.location.pathname.toLowerCase());

    navLinks.forEach(link => {
        const linkPath = normalizePath(new URL(link.href).pathname.toLowerCase());

        if (currentPath === linkPath || currentPath.startsWith(linkPath + "/")) {
            if (link.getAttribute("data-top-menu") == "true") {
                link.classList.add('text-blue-light', 'font-medium');
            } else {
                link.classList.add('text-blue', 'font-medium');
            }

            const bgShape = link.querySelector('.nav-active-bg');
            if (bgShape) {
                bgShape.classList.remove('opacity-0');
                bgShape.classList.add('opacity-100');
            }
        }
    });


    mobileNavLinks.forEach(link => {
        const linkPath = normalizePath(new URL(link.href).pathname.toLowerCase());

        if (currentPath === linkPath || currentPath.startsWith(linkPath + "/")) {
            link.classList.add('text-white', 'font-medium', '!border-b-[0px]');

            const parentLi = link.closest('li');
            if (parentLi) {
                parentLi.classList.add('bg-blue-light');
            }
        }
    });

    document.addEventListener('DOMContentLoaded', () => {
        const phoneButtonToggle = document.querySelector('.js-mobile-phone-menu-toggle');
        const branchMenus = document.querySelectorAll('.js-branch-menu');
        const phoneIcon = document.querySelector('.js-mobile-phone-icon');

        if (!phoneButtonToggle || !branchMenus.length) return;

        phoneButtonToggle.addEventListener('click', () => {
            branchMenus.forEach(menu => {
                const isOpen = menu.classList.contains('open');

                if (isOpen) {
                    menu.classList.remove('open', 'max-h-[60px]');
                    phoneIcon.classList.remove('bg-blue-light', 'text-white');
                } else {
                    menu.classList.add('open', 'max-h-[60px]');
                    phoneIcon.classList.add('bg-blue-light', 'text-white');
                }
            });
        });
    });

}
